import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Team from './components/Team';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';

import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <CustomCursor />
        <Header />
        <Hero />
        <About />
        <Services />
        <Projects />
        <Team />
        <CTA />
        <Contact />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;

